import { useContext, useState } from 'react';
import { useTheme, Box, Typography, Link, Button, Paper } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import CookieIcon from '@mui/icons-material/Cookie';
import { GlobalContext } from '../contexts/global-context';

export const CookieConsentBanner = () => {
    const theme = useTheme();
    const { isMobile } = useContext(GlobalContext);
    const [showBanner, setShowBanner] = useState(() => {
        // Check if user has already made a choice
        return !localStorage.getItem('plancrafted-cookie-consent');
    });

    const handleAccept = () => {
        localStorage.setItem('plancrafted-cookie-consent', 'accepted');
        setShowBanner(false);
    };

    const handleDecline = () => {
        localStorage.setItem('plancrafted-cookie-consent', 'declined');
        setShowBanner(false);
    };

    if (!showBanner) {
        return null;
    }

    return (
        <Paper
            elevation={8}
            sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 9999,
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                p: isMobile ? 2 : 3,
            }}
        >
            <Box sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: 2,
                flexDirection: isMobile ? 'column' : 'row',
                textAlign: isMobile ? 'center' : 'left',
                maxWidth: '1200px',
                mx: 'auto'
            }}>
                {!isMobile && (
                    <CookieIcon sx={{ 
                        fontSize: '24px', 
                        color: theme.palette.secondary.main,
                        flexShrink: 0 
                    }} />
                )}
                <Box sx={{ flex: 1 }}>
                    <Typography 
                        variant={isMobile ? 'body2' : 'body1'}
                        sx={{ 
                            fontWeight: 500,
                            mb: isMobile ? 1 : 0,
                            lineHeight: 1.4
                        }}
                    >
                        We use cookies to enhance your woodworking experience and analyze site usage. 
                        Your privacy matters to us.{' '}
                        <Link 
                            component={RouterLink}
                            to="/privacy-policy" 
                            sx={{ 
                                color: theme.palette.secondary.main,
                                textDecoration: 'underline',
                                '&:hover': {
                                    color: theme.palette.secondary.light,
                                }
                            }}
                        >
                            Learn more
                        </Link>
                    </Typography>
                </Box>
                <Box sx={{ 
                    display: 'flex',
                    gap: 1,
                    justifyContent: isMobile ? 'center' : 'flex-end',
                    flexShrink: 0
                }}>
                    <Button
                        variant="outlined"
                        onClick={handleDecline}
                        size={isMobile ? 'small' : 'medium'}
                        sx={{
                            color: theme.palette.primary.contrastText,
                            borderColor: theme.palette.primary.contrastText,
                            '&:hover': {
                                borderColor: theme.palette.primary.contrastText,
                                backgroundColor: 'rgba(255, 255, 255, 0.1)'
                            }
                        }}
                    >
                        Decline
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleAccept}
                        size={isMobile ? 'small' : 'medium'}
                        sx={{
                            backgroundColor: theme.palette.secondary.main,
                            color: theme.palette.secondary.contrastText,
                            '&:hover': {
                                backgroundColor: theme.palette.secondary.dark
                            }
                        }}
                    >
                        Accept All
                    </Button>
                </Box>
            </Box>
        </Paper>
    );
};